// extracted by mini-css-extract-plugin
module.exports = {"switch":"usersList_switch__1-XhN","usersTable":"usersList_usersTable__3Qtm0"};